export { CompanyQRsTable } from './CompanyQRsTable'
